import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const AreaIcon = createIcon(
  'Area',
  <polygon points="0 20 0 14.8817626 6.2536715 10.2032189 11.7448904 15.0851399 20 7 20 20" />,
  { viewBox: '-2 -2 24 24' }
);

AreaIcon.warning = true;

export default AreaIcon;
